import React, { useEffect, useState } from 'react'
import {
    Box, Grid, Paper, Typography, Card,
    CardContent, Divider,
} from '@mui/material';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

import { liveTrackinglayoutSelector } from '../../../features/layout/layoutSlice';
import { useSelector } from 'react-redux';
import FuelActivityTimeLine from './FuelActivityTimeLine';

const FuelActivity = ({ reportData }) => {

    const dimentions = useSelector(liveTrackinglayoutSelector);
    const [ready, setReady] = useState(false);
    const [chartData, setChartData] = useState(null);
    const [distReady, setDistReady] = useState(false);

    useEffect(() => {
        if (ready) {
            const sh = reportData.idleConsumption ? reportData.idleConsumption : 0;
            const dh = reportData.runningConsumption ? reportData.runningConsumption : 0;
            setChartData(
                {
                    labels: [
                        'Running',
                        'Idling',
                    ],
                    datasets: [{
                        label: 'Liters',
                        data: [parseFloat(dh), parseFloat(sh)],
                        backgroundColor: [
                            'RoyalBlue',
                            'DarkGray',
                        ],
                        hoverOffset: 4,
                        barThickness: 40,
                    }]
                }
            );
        }
        console.log("Fuel Report Display", ready, reportData);

    }, [reportData, ready]);//

    const [plotData, setPlotData] = useState(null);
    const [disPlotData, setDisPlotData] = useState(null);
    const [plotAvailable, setPlotAvailable] = useState(false);
    const [distPlotAvailable, setDistPlotAvailable] = useState(false);
    const [maxLevel, setMaxLevel] = useState({ min: 0, max: 50 });
    const [distMaxLevel, setDistMaxLevel] = useState({ min: 0, max: 50 });

    useEffect(() => {
        if (reportData) {
            const { fuelPlotData, fuelDistPlotData } = reportData;
            if (fuelPlotData && fuelPlotData.length > 1) {
                let pdata = [];
                fuelPlotData.forEach(p => {
                    if (!isNaN(p.vol)) {
                        pdata.push({ name: p.time, value: p.vol, unit: 'Liter' });
                    }
                })
                setPlotData(pdata);
                setPlotAvailable(true);
                let levelArr = fuelPlotData.map(p => parseFloat(p.vol));
                levelArr = levelArr.filter(p => !isNaN(p));
                const max = Math.max(...levelArr) + 10;
                const min = Math.min(...levelArr) - 10;
                //console.log("Time plot min max", min, max);
                setMaxLevel({ min, max });
            }

            if (fuelDistPlotData && fuelDistPlotData.length > 5) {
                let pdistdata = [];
                fuelDistPlotData.forEach(p => {
                    if (!isNaN(p.dist) && !isNaN(p.vol)) {
                        pdistdata.push({ name: p.dist.toFixed(0), value: p.vol, unit: 'Liter', time: p.time });
                    }
                })
                setDisPlotData(pdistdata);
                setDistPlotAvailable(true);
                let levelArrDist = fuelDistPlotData.map(p => parseFloat(p.vol));
                levelArrDist = levelArrDist.filter(p => !isNaN(p));
                const max = Math.max(...levelArrDist) + 10;
                const min = Math.min(...levelArrDist) - 10;
                //console.log("Dist plot min", min, "max", max, levelArrDist);
                setDistMaxLevel({ min, max });
            }
            //console.log("Dist Plot", fuelDistPlotData);
            //console.log("reportData", reportData);
        }
    }, [reportData, ready]);

    useEffect(() => {
        const { fuelPlotData, fuelDistPlotData, startLoc, endLoc } = reportData;
        if (fuelPlotData && fuelPlotData.length > 0) {
            if (startLoc && endLoc) {
                setReady(true);
            }

        }
        if (fuelDistPlotData && fuelDistPlotData.length > 0) {
            if (startLoc && endLoc) {
                setDistReady(true);
            }

        }
        //console.log("Report", reportData);
    }, [reportData])

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip">
                    <p className="label"><b>{`Distance: ${label} Km`}</b></p>
                    <p className="label">{`Fuel: ${payload[0].payload.value} Liters`}</p>
                    <p className="labeel">{`${payload[0].payload.time}`}</p>
                </div>
            );
        }

        return null;
    };

    if (ready) {
        return (
            <Paper style={{ ...dimentions.reportDetailViewBottom, overflow: 'auto' }}>
                <div style={{ margin: '10px', marginRight: '5px' }}>
                    <Grid container spacing={1}>
                        <Grid
                            item
                            container
                            spacing={2}
                            sm={12}
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="stretch"
                        >
                            <Grid item container sm={12}>
                                <Card style={{ backgroundColor: 'White', width: '100%' }} variant="outlined">
                                    <CardContent>
                                        <Typography variant="h6" style={{ color: 'RoyalBlue' }}><b>Report Summary</b></Typography>
                                        <Divider />
                                        <br />
                                        <Grid container>
                                            <Grid item sm={2}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                    From
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={10}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                    {`${moment(reportData.reqBody.timeFrom).format('Do MMM YY hh:mm A')}`}
                                                </Typography>
                                                <Typography gutterBottom variant="body1" style={{ color: 'RoyalBlue' }}>
                                                    {reportData.startLoc && `${reportData.startLoc.net_addr}`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={2}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                    To
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={10}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'Navy' }}>
                                                    {`${moment(reportData.reqBody.timeTo).format('Do MMM YY hh:mm A')}`}
                                                </Typography>
                                                <Typography gutterBottom variant="body1" style={{ color: 'RoyalBlue' }}>
                                                    {reportData.endLoc && `${reportData.endLoc.net_addr}`}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>


                            <Grid item container sm={4}>
                                <Card style={{ /*backgroundColor: 'rgba(210, 105, 30, 1)',*/ width: '100%', borderColor: 'SaddleBrown', borderStyle: 'solid', borderWidth: '1px' }}>
                                    <CardContent>
                                        <Typography variant="h5" style={{ color: 'SaddleBrown' }}>Summary</Typography>
                                        <Divider style={{ background: 'SaddleBrown' }} />
                                        <br />
                                        <Grid container spacing={1} direction="row">
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body2" style={{ color: 'SaddleBrown' }}>
                                                    Distance
                                                </Typography>

                                            </Grid>
                                            <Grid item sm={1}></Grid>
                                            <Grid item sm={7}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'SaddleBrown' }} display="inline">
                                                    {`${reportData.totalDistance}`}
                                                </Typography>
                                                <Typography gutterBottom variant="body2" style={{ color: 'SaddleBrown' }} display="inline">
                                                    {` Km`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'SaddleBrown', fontSize: 14 }}>
                                                    Consumed
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={1}></Grid>
                                            <Grid item sm={7}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'SaddleBrown' }}>
                                                    {`${reportData.consumption} L`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'SaddleBrown', fontSize: 14 }}>
                                                    Mileage
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={1}></Grid>
                                            <Grid item sm={7}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'SaddleBrown' }}>
                                                    {`${reportData.mileage} Km/L`}
                                                </Typography>
                                            </Grid>

                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            {/* Engine Idle */}
                            {/**
                            <Grid item container sm={3}>
                                <Card style={{ width: '100%', borderColor: 'MidnightBlue', borderStyle: 'solid', borderWidth: '1px' }}>
                                    <CardContent>
                                        <Typography variant="h5" style={{ color: 'MidnightBlue' }}>Engine Idle</Typography>
                                        <Divider style={{ background: 'MidnightBlue' }} />
                                        <br />
                                        <Grid container spacing={1} direction="row">
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body2" style={{ color: 'MidnightBlue' }}>
                                                    Duration
                                                </Typography>

                                            </Grid>
                                            <Grid item sm={1}></Grid>
                                            <Grid item sm={7}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'MidnightBlue' }} display="inline">
                                                    {`${reportData.idleDuration}`}
                                                </Typography>
                                                <Typography gutterBottom variant="body2" style={{ color: 'MidnightBlue' }} display="inline">
                                                    {` `}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'MidnightBlue', fontSize: 14 }}>
                                                    Consumed
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={1}></Grid>
                                            <Grid item sm={7}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'MidnightBlue' }}>
                                                    {`${reportData.idleConsumption} L`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'MidnightBlue', fontSize: 14 }}>
                                                    Average
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={1}></Grid>
                                            <Grid item sm={7}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'MidnightBlue' }}>
                                                    {`${reportData.idleAverage} L/hr`}
                                                </Typography>
                                            </Grid>

                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
*/}
                            <Grid item container sm={4}>
                                <Card style={{ /*backgroundColor: 'rgba(30, 144, 255,1)',*/ width: '100%', borderColor: 'ForestGreen', borderStyle: 'solid', borderWidth: '1px' }}>
                                    <CardContent>
                                        <Typography variant="h5" style={{ color: 'ForestGreen' }}>Levels</Typography>
                                        <Divider style={{ background: 'ForestGreen' }} />
                                        <br />
                                        <Grid container spacing={1} direction="row">
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'ForestGreen' }}>
                                                    Start Vol
                                                </Typography>

                                            </Grid>
                                            <Grid item sm={1}></Grid>
                                            <Grid item sm={7}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'ForestGreen' }} display="inline">
                                                    {`${reportData.startLevel}`}
                                                </Typography>
                                                <Typography gutterBottom variant="body2" style={{ color: 'ForestGreen' }} display="inline">
                                                    {` L`}
                                                </Typography>
                                            </Grid>

                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body1" style={{ color: 'ForestGreen' }}>
                                                    End Vol
                                                </Typography>

                                            </Grid>
                                            <Grid item sm={1}></Grid>
                                            <Grid item sm={7}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'ForestGreen' }} display="inline">
                                                    {`${reportData.endLevel}`}
                                                </Typography>
                                                <Typography gutterBottom variant="body2" style={{ color: 'ForestGreen' }} display="inline">
                                                    {` L`}
                                                </Typography>
                                            </Grid>

                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item container sm={4}>
                                <Card style={{ width: '100%', borderColor: 'Tomato', borderStyle: 'solid', borderWidth: '1px' }}>
                                    <CardContent>
                                        <Typography variant="h5" style={{ color: 'Tomato' }}>Tank Activity</Typography>
                                        <Divider style={{ background: 'Tomato' }} />
                                        <br />
                                        <Grid container spacing={1} direction="row">
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body2" style={{ color: 'Tomato' }}>
                                                    Filling
                                                </Typography>

                                            </Grid>
                                            <Grid item sm={1}></Grid>
                                            <Grid item sm={7}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'Tomato' }} display="inline">
                                                    {`${reportData.totalFills} L`}
                                                </Typography>
                                                <Typography gutterBottom variant="body2" style={{ color: 'Tomato' }} display="inline">
                                                    {` (${reportData.fillCount} times)`}
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={4}>
                                                <Typography gutterBottom variant="body2" style={{ color: 'Tomato', fontSize: 12 }}>
                                                    Theft
                                                </Typography>

                                            </Grid>
                                            <Grid item sm={1}></Grid>
                                            <Grid item sm={7}>
                                                <Typography gutterBottom variant="h6" style={{ color: 'Tomato', fontSize: 18 }} display="inline">
                                                    {`${reportData.totalTheft} L`}
                                                </Typography>
                                                <Typography gutterBottom variant="body2" style={{ color: 'Tomato' }} display="inline">
                                                    {` (${reportData.theftCount} times)`}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>

                        </Grid>

                        {
                            reportData.fillsAndThefts && reportData.fillsAndThefts.length > 0 &&

                            <Grid container item sm={12}>
                                <Card style={{ width: '100%' }}>
                                    <CardContent>
                                        <div style={{ margin: '5px' }}>
                                            <Grid container spacing={1}>
                                                <Grid item sm={12}>
                                                    <Typography variant="h6" style={{ color: 'RoyalBlue' }}><b>Fuel Fillings & Thefts</b></Typography>
                                                </Grid>
                                                <Grid item sm={12}><Box style={{ height: '10px' }}></Box></Grid>
                                                <Grid item container sm={12} style={{ backgroundColor: 'Gray' }} spacing={1}>
                                                    <Grid item sm={2}><Typography gutterBottom variant="body1"><b style={{ color: 'White' }}>Activity</b></Typography></Grid>
                                                    <Grid item sm={2}><Typography gutterBottom variant="body1"><b style={{ color: 'White' }}>Time</b></Typography></Grid>
                                                    <Grid item sm={1}><Typography gutterBottom variant="body1"><b style={{ color: 'White' }}>Before</b></Typography></Grid>
                                                    <Grid item sm={1}><Typography gutterBottom variant="body1"><b style={{ color: 'White' }}>Quantity</b></Typography></Grid>
                                                    <Grid item sm={1}><Typography gutterBottom variant="body1"><b style={{ color: 'White' }}>After</b></Typography></Grid>
                                                    <Grid item sm={5}><Typography gutterBottom variant="body1"><b style={{ color: 'White' }}>Location</b></Typography></Grid>
                                                </Grid>

                                                {
                                                    reportData.fillsAndThefts.map((item, index) =>
                                                        <Grid item container sm={12} key={index} spacing={1}>
                                                            <Grid item sm={2}><Typography gutterBottom variant="body1">{`${item.event_type.toUpperCase()}`}</Typography></Grid>
                                                            <Grid item sm={2}><Typography gutterBottom variant="body1">{`${moment(item.time).format('D/M/Y h:mm A')}`}</Typography></Grid>
                                                            <Grid item sm={1}><Typography gutterBottom variant="body1">{`${item.startVol}`}</Typography></Grid>
                                                            <Grid item sm={1}><Typography gutterBottom variant="body1"><b>{`${item.volume}`}</b></Typography></Grid>
                                                            <Grid item sm={1}><Typography gutterBottom variant="body1">{`${item.endVol}`}</Typography></Grid>
                                                            <Grid item sm={5}><Typography gutterBottom variant="body1"><Link to={{ pathname: `https://www.google.com/maps/search/?api=1&query=${item.lat},${item.lng}` }} target="_blank" >{item.address.net_addr}</Link></Typography></Grid>
                                                        </Grid>
                                                    )
                                                }
                                            </Grid>
                                        </div>
                                    </CardContent>
                                </Card>
                            </Grid>
                        }
                        <br />
                        <br />
                        <Grid container item sm={12} spacing={1}>
                            <Grid conatiner item sm={8}>
                                <Grid item sm={12}>
                                    {
                                        plotAvailable &&
                                        <Card style={{ backgroundColor: 'White', width: '100%' }} variant="outlined">
                                            <CardContent>
                                                <Typography variant="h6" style={{ color: 'RoyalBlue' }}><b>Fuel Level vs Time Graph</b></Typography>
                                                <Divider />
                                                <br />

                                                    <Grid item container sm={12}>
                                                        <ResponsiveContainer width="95%" height={400}>
                                                            <LineChart data={plotData} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
                                                                <Line
                                                                    name="Fuel in Tank"
                                                                    type="linear"
                                                                    dataKey="value"
                                                                    stroke="dodgerblue"
                                                                    dot={{ stroke: 'blue', strokeWidth: 1, r: 1 }}
                                                                    activeDot={{ stroke: 'midnightblue', strokeWidth: 2, r: 2 }}
                                                                />
                                                                <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
                                                                <XAxis dataKey="name" />
                                                                <YAxis domain={[maxLevel.min, maxLevel.max]} />
                                                                <Tooltip />
                                                            </LineChart>
                                                        </ResponsiveContainer>
                                                    </Grid>

                                                </CardContent>
                                            </Card>

                                    }
                                </Grid>

                                <br />
                                <Grid item sm={12}>
                                    {
                                        distPlotAvailable && distReady &&
                                        <Card style={{ backgroundColor: 'White', width: '100%' }} variant="outlined">
                                            <CardContent>
                                                <Typography variant="h6" style={{ color: 'ForestGreen' }}><b>Fuel Level vs Distance Graph</b></Typography>
                                                <Divider />
                                                <br />

                                                    <Grid item container sm={12}>
                                                        <ResponsiveContainer width="95%" height={400}>
                                                            <LineChart data={disPlotData} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
                                                                <Line
                                                                    name="Fuel in Tank"
                                                                    type="linear"
                                                                    dataKey="value"
                                                                    stroke="ForestGreen"
                                                                    dot={{ stroke: 'LimeGreen', strokeWidth: 1, r: 1 }}
                                                                    activeDot={{ stroke: 'Green', strokeWidth: 2, r: 2 }}
                                                                />
                                                                <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
                                                                <XAxis dataKey="name" />
                                                                <YAxis domain={[distMaxLevel.min, distMaxLevel.max]} />
                                                                <Tooltip content={<CustomTooltip />} />
                                                            </LineChart>
                                                        </ResponsiveContainer>
                                                    </Grid>

                                                </CardContent>
                                            </Card>

                                    }
                                </Grid>
                            </Grid>
                            <Grid item sm={4}>
                                <Card style={{ backgroundColor: 'White', width: '100%' }} variant="outlined">
                                    <CardContent>
                                        <Typography variant="h6" style={{ color: 'ForestGreen' }}><b>Activity Timeline</b></Typography>
                                        <Divider />
                                        <br />
                                        {
                                            reportData.fuelTimeLine &&
                                            <Grid item container sm={12}>
                                                <FuelActivityTimeLine data={reportData.fuelTimeLine} />
                                            </Grid>
                                        }


                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>






                        <Grid item sm={12}><Box style={{ height: '10px' }}></Box></Grid>
                    </Grid>
                </div>
            </Paper >
        )
    } else {
        return null;
    }

}

export default FuelActivity;